import { Field } from 'react-final-form';

import {
  Button,
  IconButton,
  Icons,
  Input,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { RffForm } from '@cast/shared-rff-ui';

type BugReportFormProps = {
  onClose: () => void;
  onSubmit: (details: string) => void;
};

export const BugReportForm = ({ onClose, onSubmit }: BugReportFormProps) => {
  return (
    <Stack
      p={16}
      gap={8}
      border="1px solid"
      borderColor={tokens.theme.border.structural.neutral}
      borderRadius="4px"
      bgcolor={tokens.theme.bg.structural.surface}
    >
      <Stack
        direction="row"
        gap={8}
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Stack gap={4}>
          <Typography variant="P14M" color={tokens.theme.fg.structural.primary}>
            Report a technical issue / bug
          </Typography>
          <Typography
            variant="P12R"
            color={tokens.theme.fg.structural.secondary}
          >
            Tell us what happened. Relevant context will be attached
            automatically.
          </Typography>
        </Stack>
        <IconButton
          type="button"
          variant="ghost"
          size="sm"
          aria-label="Close bug report form"
          onClick={onClose}
        >
          <Icons.X size={16} color={tokens.theme.fg.action.onGhost} />
        </IconButton>
      </Stack>
      <RffForm
        initialValues={{ text: '' }}
        onSubmit={({ text }: { text: string }) => onSubmit(text)}
      >
        {({ values }) => (
          <Stack direction="row" gap={8} alignItems="center">
            <Field name="text">
              {({ input }) => (
                <Input
                  {...input}
                  autoFocus
                  placeholder="Describe the issue..."
                  aria-label="Bug report details"
                  size="small"
                  sx={{ flex: 1 }}
                />
              )}
            </Field>
            <Button
              type="submit"
              variant="primary"
              size="sm"
              disabled={!values.text?.trim()}
            >
              Submit
            </Button>
          </Stack>
        )}
      </RffForm>
    </Stack>
  );
};
